module.exports = __webpack_public_path__ + "img/finish.80c2a892.png";